import React, { Component } from "react";
import cn from "classnames";

import IconClose from "../../../containers/assets/icon_close.svg";
import MarketButton from "../../../containers/market-button";
import ProgressBarItem from "./progress-bar-item";

class PeerEvaluationModal extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { show } = this.props;

    /* Hide background scrollbar */
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }

  render() {
    const {
      children,
      show,
      progressBar,
      onHide,
      onSubmit,
      submitButtonText,
      surveyId,
      currentPage,
      countOfPages,
      goNext,
      goPrev,
      canSubmit,
      isFinalScreen,
      readonlyMode,
      linearExtraId = '',
      isInstructorMode = false,
      isIntroScreen,
    } = this.props;

    return (
      <div className={cn("peerModal", { peerModal_show: show })}>
        <div className="modalWrapper">
          <div className="modalHeader">
            <div className="progressBarWrapper">
              {progressBar.map(item => (
                <ProgressBarItem
                  key={item.id}
                  id={item.id}
                  surveyId={surveyId}
                  title={item.title}
                  progress={item.progress}
                  isDisabled={item.isDisabled}
                  linearExtraId={linearExtraId}
                />
              ))}
            </div>
            <div
              className="modalHeader__close"
              onClick={onHide ? onHide : null}
            >
              <img alt="Close modal window" src={IconClose} />
            </div>
          </div>
          <div className="modalContent">
            {children}
            {!isFinalScreen && !readonlyMode && (
              <MarketButton
                variant="error"
                type="solid"
                className="submitButton"
                onClick={onSubmit}
                disabled={!canSubmit}
              >
                {submitButtonText}
              </MarketButton>
            )}
            {isFinalScreen && (
              <MarketButton
                variant="error"
                type="outlined"
                className="closeButton"
                onClick={() => onHide()}
              >
                Close
              </MarketButton>
            )}
          </div>

          {(currentPage > 0 || readonlyMode === true) && countOfPages > 0 &&
            <div className="surveyPaginationWrapper">
              <div className="surveyPagination">
                {isInstructorMode !== true && currentPage > 1 &&
                  <MarketButton
                    type="solid"
                    className="surveyPaginationButton surveyPaginationLast"
                    onClick={goPrev}
                    disabled={!canSubmit}
                  >
                    <span>&lt;</span>
                    Prev
                  </MarketButton>}
                {isInstructorMode !== true && currentPage < countOfPages &&
                  <MarketButton
                    type="solid"
                    className="surveyPaginationButton surveyPaginationNext"
                    onClick={goNext}
                    disabled={!canSubmit}
                  >
                    Next
                    <span>&gt;</span>
                  </MarketButton>}
                {isInstructorMode === true && isIntroScreen === false &&
                  <MarketButton
                    type="solid"
                    className="surveyPaginationButton surveyPaginationLast"
                    onClick={goPrev}
                    disabled={!canSubmit}
                  >
                    <span>&lt;</span>
                    Prev
                  </MarketButton>}
                {isInstructorMode === true && isFinalScreen === false &&
                  <MarketButton
                    type="solid"
                    className="surveyPaginationButton surveyPaginationNext"
                    onClick={goNext}
                    disabled={!canSubmit}
                  >
                    Next
                    <span>&gt;</span>
                  </MarketButton>}
              </div>
            </div>}
        </div>
      </div>
    );
  }
}

export default PeerEvaluationModal;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/peer-evaluation-modal/index.js